import { api } from "./client";

export function getPushPublicKey(): Promise<{ publicKey: string | null; configured: boolean }> {
  return api(`/push/public-key`);
}

export function subscribePush(input: {
  endpoint: string;
  p256dh: string;
  auth: string;
  ua?: string;
}): Promise<{ ok: true }> {
  return api(`/push/subscribe`, { method: "POST", body: input });
}

export function unsubscribePush(endpoint: string): Promise<{ ok: true }> {
  return api(`/push/unsubscribe`, { method: "POST", body: { endpoint } });
}

export function followupCampaign(
  campaignId: string,
  templateId?: string,
): Promise<{
  attempted: number;
  sent: number;
  skipped: { email: string; reason: string }[];
  failed: { email: string; error: string }[];
}> {
  return api(`/campaigns/${campaignId}/followup`, {
    method: "POST",
    body: templateId ? { templateId } : {},
  });
}
